import {
  Box,
  Flex,
  // Heading,
  // Text,
  // HStack,
  // LinkBox,
  // LinkOverlay,
  // Drawer,
  // DrawerBody,
  // DrawerFooter,
  // DrawerHeader,
  // DrawerOverlay,
  // DrawerContent,
  // DrawerCloseButton,
  // IconButton,
  // useDisclosure,
  // AspectRatio,
  // Icon,
} from '@chakra-ui/react'
import React, { useMemo, useRef } from 'react'
import { IoChevronBack } from 'react-icons/io5'
import { Link } from 'gatsby'

import Button from '../components/Button'
// import Blocks from './Blocks'
import RatioImage from './RatioImage'

const NavHeading = ({ data, backUrl }) => {
  // const { isOpen, onOpen, onClose } = useDisclosure()
  // const btnRef = useRef()
  // const listBlocks = useMemo(() => data?.blocks.find(b => b.type === 'list'), [data])
  return (
    <Flex alignItems="center" width={`full`} px="2">
      {/* <IconButton
        onClick={() => window.history.back()}
        colorScheme="whiteAlpha"
        size="md"
        color="black"
        icon={<FaChevronLeft />}
        title="回上一頁"
        _hover={{
          color: 'black'
        }}
        _focus={{
          color: 'black'
        }}
      /> */}
      <Button
        leftIcon={<IoChevronBack size="1.125em" />}
        to={backUrl ?? `/${data.slug}`}
        variant="link"
        colorScheme="blackAlpha"
        color="custom.text"
      >
        回上一頁
      </Button>

      <Box flex="1" />
      <Link to={`/${data.slug}`}>
        <RatioImage
          width="3em"
          src={data.avatar}
          alt={data.name}
          boxShadow="sm"
          ratio={1}
          rounded="full"
        />
      </Link>
      {/* <IconButton
        ref={btnRef}
        colorScheme="whiteAlpha"
        size="md"
        color="black"
        icon={<FaBars />}
        title="選單"
        _hover={{
          color: 'black'
        }}
        _focus={{
          color: 'black'
        }}
        onClick={onOpen}
      />
      <Drawer
        isOpen={isOpen}
        placement='right'
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader fontSize={`md`}>{data.name}</DrawerHeader>

          <DrawerBody>
            {listBlocks && (
              <Blocks blocks={[listBlocks]} links={data.links} />
            )}
          </DrawerBody>
          <DrawerFooter>
            <Button to={`/${data.slug}`} isFullWidth variant="outline" colorScheme="primary">
              回首頁
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer> */}
    </Flex>
  )
}

export default NavHeading
